var _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisAmministrative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 141,
    viewBox: "0 0 155 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.95431 0 0 8.95431 0 20V121C0 132.046 8.95431 141 20 141H100C111.046 141 120 132.046 120 121V20C120 8.95431 111.046 0 100 0H20ZM21.5 14C17.3579 14 14 17.3579 14 21.5C14 25.6421 17.3579 29 21.5 29H98.5C102.642 29 106 25.6421 106 21.5C106 17.3579 102.642 14 98.5 14H21.5ZM14 53C14 47.4771 18.4772 43 24 43H96C101.523 43 106 47.4772 106 53V89C106 94.5229 101.523 99 96 99H24C18.4771 99 14 94.5229 14 89V53ZM68.5 113C64.3579 113 61 116.358 61 120.5C61 124.642 64.3579 128 68.5 128H98.5C102.642 128 106 124.642 106 120.5C106 116.358 102.642 113 98.5 113H68.5Z",
    fill: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134 118L134 21L155 21L155 118L134 118Z",
    fill: "#6F6F6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155 134C155 137.866 151.866 141 148 141L141 141C137.134 141 134 137.866 134 134L134 125L155 125L155 134Z",
    fill: "#6F6F6F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134 21L142.711 3.57771C143.448 2.10361 145.552 2.10361 146.289 3.57771L155 21L134 21Z",
    fill: "#6F6F6F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 52,
    width: 76,
    height: 13,
    rx: 6.5,
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisAmministrative);
export default __webpack_public_path__ + "static/media/dis-amministrative.baf2a2e261f74a520128233958de0db4.svg";
export { ForwardRef as ReactComponent };